var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"instock-cart"},[_c('cart',{attrs:{"products":_vm.products,"mode":_vm.StockType.StockIn},on:{"update":_vm.updateCart,"submit":_vm.trySubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }